import { useTranslation } from "react-i18next";
import { HelpCircle, ExternalLink } from "lucide-react";
import i18n from "../../lib/i18n";

const SLUG = "come-funziona-lo-squad-score";

function guideUrl(): string {
  const lang = (i18n.language || "it").toLowerCase().split("-")[0];
  if (lang === "en") return `https://elevenbase.pro/en/guides/${SLUG}`;
  if (lang === "de") return `https://elevenbase.pro/de/anleitungen/${SLUG}`;
  return `https://elevenbase.pro/it/guida/${SLUG}`;
}

export function SquadScoreGuideButton() {
  const { t } = useTranslation("settings");
  return (
    <a
      href={guideUrl()}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 rounded-full border bg-card hover:bg-muted/60 px-2.5 py-1 text-xs font-medium text-foreground/80 transition-smooth"
    >
      <HelpCircle className="h-3.5 w-3.5" />
      {t("squadScore.guide.cta")}
      <ExternalLink className="h-3 w-3 opacity-60" />
    </a>
  );
}
